<template>
  <span>{{ toYMD(params.value) }}</span>
</template>
<script>
import { DateUtil } from "@/utils";

export default {
  name: "CellRendererDate",
  computed: {
    toYMD() {
      return value => {
        if (value) {
          let time = DateUtil.toYMD(value, "YYYY年MM月DD日 HH時mm分");
          return `${time}`;
        }
        return "---";
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
